// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'

Vue.use(Vant);
Vue.prototype.baseUrl = "https://www.njpkwater.com/"
// Vue.prototype.baseUrl = "http://0.0.0.0:8000/"
Vue.config.productionTip = false
axios.defaults.withCredentials=true
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js